import { render, staticRenderFns } from "./NewPasswordPopup.vue?vue&type=template&id=06a5132e&scoped=true"
import script from "./NewPasswordPopup.vue?vue&type=script&lang=js"
export * from "./NewPasswordPopup.vue?vue&type=script&lang=js"
import style0 from "./NewPasswordPopup.vue?vue&type=style&index=0&id=06a5132e&prod&lang=scss&scoped=true"
import style1 from "./NewPasswordPopup.vue?vue&type=style&index=1&id=06a5132e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a5132e",
  null
  
)

export default component.exports